import { createSelector } from 'reselect'

import { selectLandingState } from './selectLandingState'

export const selectIsLandingNoData = createSelector(
  [selectLandingState],
  ({ isNoData }) => isNoData
)
